export const version = 'v2.2.4-2286-g142a7e8e6'
